import React from 'react'

import { Table, Row } from 'antd'
import NextLink from 'next/link'

const columns = (foType, brokers) => [
  {
    title: 'Charge',
    dataIndex: 'charge',
  },
  {
    title: `${foType} Futures (${brokers[0].attributes.name})`,
    className: 'column-money',
    dataIndex: 'futures1',
    align: 'right' as const,
  },
  {
    title: `${foType} Options (${brokers[0].attributes.name})`,
    className: 'column-money',
    dataIndex: 'options1',
    align: 'right' as const,
  },
  {
    title: `${foType} Futures (${brokers[1].attributes.name})`,
    className: 'column-money',
    dataIndex: 'futures2',
    align: 'right' as const,
  },
  {
    title: `${foType} Options (${brokers[1].attributes.name})`,
    className: 'column-money',
    dataIndex: 'options2',
    align: 'right' as const,
  },
]

const renderCommodityLinks = (brokers) => {
  return (
    <>
      {brokers.map((broker) => {
        return broker.attributes.commodity_trading ? (
          <Row style={{ width: '100%' }}>
            <NextLink
              href="/broker/[slug]/commodity-trading"
              as={`/broker/${broker.attributes.slug}/commodity-trading`}
            >
              Read More about{` ${broker.attributes.name} `}Commodity Trading
            </NextLink>
          </Row>
        ) : null
      })}
    </>
  )
}

const renderCurrencyLinks = (brokers) => {
  return (
    <>
      {brokers.map((broker) => {
        return broker.attributes.currency_trading ? (
          <Row style={{ width: '100%' }}>
            <NextLink
              href="/broker/[slug]/commodity-trading"
              as={`/broker/${broker.attributes.slug}/currency-trading`}
            >
              Read More about{` ${broker.attributes.name} `}Currency Trading
            </NextLink>
          </Row>
        ) : null
      })}
    </>
  )
}

const keyNameMap = {
  brokerage: 'Brokerage',
  stt: 'Securities Transaction Tax (STT)',
  turnover: 'Transaction / Turnover Charges',
  gst: 'Goods and Services Tax (GST)',
  sebi: 'SEBI Charges',
  stamp: 'Stamp Charges',
}

export default function FOBrokerage({
  brokers,
  futuresBrokerage1,
  optionsBrokerage1,
  futuresBrokerage2,
  optionsBrokerage2,
  foType,
}) {
  const data = Object.keys(futuresBrokerage1)
    .filter((k) => k !== '__typename')
    .map((k) => ({
      key: k,
      charge: keyNameMap[k],
      futures1: futuresBrokerage1[k],
      options1: optionsBrokerage1[k],
      futures2: futuresBrokerage2[k],
      options2: optionsBrokerage2[k],
    }))

  if (
    futuresBrokerage1 &&
    optionsBrokerage1 &&
    futuresBrokerage2 &&
    optionsBrokerage2
  ) {
    return (
      <>
        <Table
          columns={columns(foType, brokers)}
          dataSource={data}
          bordered
          title={null}
          pagination={false}
          style={{ marginBottom: '16px' }}
        />
        {foType === 'Commodity' ? renderCommodityLinks(brokers) : null}
        {foType === 'Currency' ? renderCurrencyLinks(brokers) : null}
      </>
    )
  }

  return null
}
